import gql from "graphql-tag";
const ScreenerIndicatorFieldsFragment = gql`
  fragment ScreenerIndicatorFields on ScreenerIndicator {
    ... on ScreenerIndicatorDetails {
      objectId
      name
      description
      abbreviation
      objectId
      viewerCanSee
      viewerCanFilter
      viewerCanSort
    }
    ... on ScreenerStandardizedIndicator {
      kind
      category
      dataSource
    }
    ... on ScreenerStaticIndicator {
      kind
    }
    ... on ScreenerPercentValueChangeIndicator {
      category
      kind
      dataSource
    }
  }
`;
export default ScreenerIndicatorFieldsFragment;
